import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import AuthLayout from 'layouts/AuthLayout'
import ResetPasswordConfirm from 'components/PageComponents/Auth/ResetPassword/ResetPasswordConfirm'

const ResetPasswordConfirmPage = () => (
  <>
    <Helmet>
      <title>Skefto: Reset Password</title>
    </Helmet>
    <AuthLayout>
      <ResetPasswordConfirm />
    </AuthLayout>
  </>
)

export default ResetPasswordConfirmPage
